export const calcProgress = (obj) => {
  const progressData = []

  Object.values(obj).forEach((item, index) => {
    if (!item.lessons) {
      const total = item.topics.length
      const per = item.topics.filter(el => el.progress).length
      progressData[index] = [total, per]
      return
    }

    let total = 0
    let totalTrue = 0

    Object
      .values(item.lessons)
      .forEach((itemDeeper) => {
        if (itemDeeper.topics.length === 0) {
          total += 1
          totalTrue += itemDeeper.progress ? 1 : 0
          return
        }

        total += itemDeeper.topics.length
        totalTrue += itemDeeper.topics.filter(el => el.progress).length
      })

    progressData[index] = [total, totalTrue]
  })

  // progress arr in percents for every item
  return progressData.map(i => Math.floor(i[1] * 100 / i[0]) || 0)
}
